// The Revieve payload contract for hair differs from skin's - it is owned by
// @notino/hair-analyzer-lib, so take the types from there rather than
// re-declaring them.
export { EHairEventName } from '@notino/hair-analyzer-lib';
export type {
  IHairTrackingEvent,
  IHairRawTrackingEventPayload,
} from '@notino/hair-analyzer-lib';

import type {
  IHairBrandSpecificPageViewFields,
  IHairRawTrackingEventPayload,
} from '@notino/hair-analyzer-lib';

/** Revieve's page_title for the first screen of the tool. */
export const HAIR_START_PAGE_TITLE = 'Start';

/**
 * The product-shaped subset of a Revieve hair tracking payload. Every field is
 * optional in the SDK contract, so consumers must handle a payload that carries
 * no product at all. Entries of `view_item_list.items` are compatible too.
 */
export type TrackedProduct = Pick<
  IHairRawTrackingEventPayload,
  'item_id' | 'item_brand' | 'item_name' | 'item_category' | 'price'
>;

/**
 * Revieve's `page_view` payload plus the brand-specific fields we add before
 * the SDK forwards it to GA4. Mirrors the Skin Analyzer's isBrandSpecificSA.
 */
export type HairPageViewPayload = Pick<
  IHairRawTrackingEventPayload,
  'page_title' | 'page_location'
> &
  IHairBrandSpecificPageViewFields;
